import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useNavigateWithSearchContext } from '../../hooks/useNavigateWithSearchContext';
import AccountLayout from '../../components/Account/AccountLayout';
import SimpleAccountDashboard from '../../components/Account/SimpleAccountDashboard';
import './OverviewPage.css';

const OverviewPage: React.FC = () => {
  const navigate = useNavigate();
  const navigateWithContext = useNavigateWithSearchContext();
  const { user } = useAuth();

  if (!user) {
    return (
      <AccountLayout activeSection="overview">
        <div className="overview-auth-required">
          <div className="overview-auth-content">
            <h1>Account Overview</h1>
            <p>Please sign in to access your account overview.</p>
            <button onClick={() => navigate('/')} className="btn-primary">
              Go to ZoningPal
            </button>
          </div>
        </div>
      </AccountLayout>
    );
  }

  return (
    <AccountLayout activeSection="overview">
      <div className="overview-page">
        <div className="overview-header">
          <h1>Account Overview</h1>
          <p className="overview-subtitle">
            Welcome back! Here's a summary of your ZoningPal account and usage.
          </p>
        </div>

        <div className="overview-content">
          {/* Account Dashboard */}
          <div className="overview-dashboard-section">
            <SimpleAccountDashboard />
          </div>

          {/* Quick Actions */}
          <div className="overview-quick-actions">
            <h2>Quick Actions</h2>
            <div className="quick-actions-grid">
              <button 
                className="quick-action-card"
                onClick={() => navigate('/account/reports')}
              >
                <div className="quick-action-content">
                  <h3>View My Reports</h3>
                  <p>Access your saved zoning analysis reports</p>
                </div>
              </button>
              
              <button 
                className="quick-action-card"
                onClick={() => navigateWithContext('/account/pricing')}
              >
                <div className="quick-action-content">
                  <h3>Purchase Credits</h3>
                  <p>Buy credits to generate zoning analysis reports</p>
                </div>
              </button>
              
              <button 
                className="quick-action-card"
                onClick={() => navigate('/account/settings')}
              >
                <div className="quick-action-content">
                  <h3>Account Settings</h3>
                  <p>Update password and security settings</p>
                </div>
              </button>
              
              <button 
                className="quick-action-card"
                onClick={() => navigate('/')}
              >
                <div className="quick-action-content">
                  <h3>Start Analysis</h3>
                  <p>Go to the main app and analyze properties</p>
                </div>
              </button>
            </div>
          </div>

          {/* Usage Tips */}
          <div className="overview-tips-section">
            <h2>Getting the Most Out of ZoningPal</h2>
            <div className="tips-grid">
              <div className="tip-card">
                <div className="tip-content">
                  <h4>Purchase Credits</h4>
                  <p>Buy credits to generate comprehensive zoning analysis reports. Each analysis costs 1 credit.</p>
                </div>
              </div>
              
              <div className="tip-card">
                <div className="tip-content">
                  <h4>AI-Powered Analysis</h4>
                  <p>Generate detailed zoning reports with development insights using our AI analysis feature.</p>
                </div>
              </div>
              
              <div className="tip-card">
                <div className="tip-content">
                  <h4>Save Your Reports</h4>
                  <p>Keep track of your analyses by saving reports to your account for future reference.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
};

export default OverviewPage; 